<div fxLayout="column" fxLayoutGap="10px" fxLayoutGap.xs="0">

    <div>

        <mat-form-field appearance="outline" angulartics2On="click" angularticsAction="selectPreFilledDate" angularticsCategory="clientOrder" ngClass.xs="full-w" class="form-nopadd full-w">
            <mat-label>{{"filterDate.periodModel"|translate}}</mat-label>
            <mat-select [(value)]="preFilledPeriod" [disabled]="inputDisabled">

                <mat-select-trigger>

                    <div fxLayoutAlign="start center">

                        <mat-icon class="primary-ico" [ngClass]="{'warn-ico' : preFilledPeriod.colored}">date_range</mat-icon>
                        <div fxFlex fxLayoutAlign="center center" [ngClass]="{'boldest warn-ico' : preFilledPeriod.colored}">
                            {{preFilledPeriod.name | capitalize}}
                        </div>

                    </div>

                </mat-select-trigger>

                <cdk-virtual-scroll-viewport itemSize="50" minBufferPx="200" maxBufferPx="400" class="example-viewport-select">
                    <mat-option *cdkVirtualFor="let period of preFilledPeriods" (click)="onPeriodChange(period)" [ngClass]="{'divider boldest warn-ico' : period.colored}" [value]="period">
                        {{period.name | capitalize}}
                    </mat-option>
                </cdk-virtual-scroll-viewport>


            </mat-select>
        </mat-form-field>

    </div>

    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="20px" fxLayoutGap.xs="0px" ngClass.xs="layout-padd height" *ngIf="!preFilledPeriod.from">

        <mat-form-field angulartics2On="click" angularticsAction="selectDateFrom" angularticsCategory="clientOrder" *ngIf="!media.isActive('xs')" class="form-nopadd">
            <mat-label>{{"filterDate.dateStart"|translate}}</mat-label>
            <div class="clicked" (click)="pickerFrom.open()">
                <input matInput [max]="today" [matDatepicker]="pickerFrom" (dateChange)="onDateFromChange()" [(ngModel)]="from" disabled>
            </div>
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker disabled="false" #pickerFrom></mat-datepicker>
        </mat-form-field>

        <mat-form-field angulartics2On="click" angularticsAction="selectDateTo" angularticsCategory="clientOrder" *ngIf="!media.isActive('xs')" class="form-nopadd">
            <mat-label>{{"filterDate.dateEnd"|translate}}</mat-label>
            <div class="clicked" (click)="pickerTo.open()">
                <input matInput [min]="from" [max]="today" [matDatepicker]="pickerTo"  (dateChange)="onDateToChange()" [(ngModel)]="to" disabled>
            </div>
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker disabled="false" #pickerTo></mat-datepicker>
        </mat-form-field>

        <mat-form-field angulartics2On="click" angularticsAction="selectDateFrom" angularticsCategory="clientOrder" *ngIf="media.isActive('xs')" class="form-nopadd">
            <mat-label>{{"filterDate.dateStart"|translate}}</mat-label>
            <div class="clicked" (click)="pickerFrom.open()">
                <input matInput [max]="today" [matDatepicker]="pickerFrom"  [(ngModel)]="from" (dateChange)="onDateFromChange()" disabled>
            </div>
            <mat-datepicker-toggle matSuffix [for]=" pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker touchUi disabled="false" #pickerFrom></mat-datepicker>
        </mat-form-field>

        <mat-form-field angulartics2On="click" angularticsAction="selectDateTo" angularticsCategory="clientOrder" *ngIf="media.isActive('xs')" class="form-nopadd">
            <mat-label>{{"filterDate.dateEnd"|translate}}</mat-label>
            <div class="clicked" (click)="pickerTo.open()">
                <input matInput [min]="from" [max]="today" [matDatepicker]="pickerTo"  (dateChange)="onDateToChange()" [(ngModel)]="to" disabled>
            </div>
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker touchUi [disabled]="false" #pickerTo></mat-datepicker>
        </mat-form-field>

    </div>

    <div fxLayoutAlign="start center" *ngIf="!preFilledPeriod.from">
        <button mat-raised-button color="primary" ngClass.xs="full-w" [disabled]="!to || !from || inputDisabled" (click)="getDataFromPeriods()">{{"button.validate"|translate}}</button>
    </div>

</div>